/*@flow*/
/** @jsx jsx */
// @ts-check
import { css, jsx, Global } from '@emotion/core';
import { useState, useEffect, createRef } from 'react';
import { useHide } from './useHide';
import { useHeight } from './useHeight';
import { Component as AreaTools } from 'comps/City/AreaTools';
import Metrics from 'comps/City/Metrics';

export function Sidebar() {
  const hide = useHide();
  const containerRef = createRef();
  const areaToolsHeight = 239;
  const height = useHeight(containerRef, areaToolsHeight);

  return (
    <div
      ref={containerRef}
      css={css(`
          display: ${hide ? 'none' : 'grid'};
          background: #f2f6f9;
          grid-template-rows: ${areaToolsHeight}px 1fr;
          @media(max-width: 775px) {
            display: none;
          }
          overflow: hidden;
        `)}
    >
      <AreaTools />
      <div css={css({ height, overflow: 'scroll' })}>
        <Metrics />
      </div>
    </div>
  );
}
